import {
  forwardRef,
  Grid,
  GridItem,
  GridProps,
} from '@chakra-ui/react';
import { SystemStyleObject } from '@chakra-ui/system';

type ColorScheme =
  | 'whiteAlpha'
  | 'blackAlpha'
  | 'gray'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'teal'
  | 'blue'
  | 'cyan'
  | 'purple'
  | 'pink'
  | 'linkedin'
  | 'facebook'
  | 'messenger'
  | 'whatsapp'
  | 'twitter'
  | 'telegram';

const defaultColorSchemes = ['pink.500', 'teal', 'cyan'];

export interface MultiProgressBarProps {
  colorSchemes?: ColorScheme[];
  value?: number[];
  itemSx?: SystemStyleObject;
  active?: {
    index: number;
    sx: SystemStyleObject;
  };
}

export const MultiProgressBar = forwardRef<
  GridProps & MultiProgressBarProps,
  'div'
>((props, ref) => {
  const {
    colorSchemes = defaultColorSchemes,
    value = [],
    itemSx,
    active,
    ...otherProps
  } = props;

  return (
    <Grid width="100%" {...otherProps} ref={ref}>
      <GridItem
        gridRow={'1'}
        gridColumnStart="1"
        width={'100%'}
        height="16px"
        bgColor="gray.500"
        sx={itemSx}
      />
      {value.map((v, i) => (
        <GridItem
          key={i}
          gridRow="1"
          gridColumnStart="1"
          width={`${v}%`}
          height="16px"
          bgColor={colorSchemes[i]}
          sx={{
            ...itemSx,
            ...(active && active.index <= i && active.sx),
          }}
        />
      ))}
    </Grid>
  );
});
